import { FC } from 'react'

import { Button, DateRange, Form, Input, Row, SelectForm } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { SPACING } from 'utils'

interface IFilters {
  control: any
  watch: any
  errors: any
  onSubmit: (_data) => void
  handleReset: () => void
}

const Filters: FC<IFilters> = ({
  control,
  watch,
  onSubmit,
  handleReset,
  errors
}) => {
  const listaSituacao = [
    { label: 'Todos', value: 'none' },
    { label: 'Bloqueado', value: 'b' },
    { label: 'Desativado', value: 'd' },
    { label: 'Pendente', value: 'p' },
    { label: 'Liberado', value: 'l' },
    { label: 'Vencido', value: 'v' }
  ]
  const cpfPass = watch('cdDocto')

  return (
    <Form onSubmit={onSubmit}>
      <Row alignItems="center">
        <Input
          control={control}
          placeholder="Nº"
          label="CPF / Passaporte"
          formValue="cdDocto"
          mask={
            isNaN(parseInt(cpfPass)) ? ['NN##########'] : ['###.###.###-##']
          }
          marginRight={SPACING.spacing20}
        />
        <Input
          control={control}
          placeholder="Nome Completo"
          label="Colaborador"
          formValue="nmUsuario"
          marginRight={SPACING.spacing20}
          type="text"
        />
        <DateRange
          control={control}
          watch={watch}
          formValue={['dtAcessoInicio', 'dtAcessoFim']}
          label={['Validade de Acesso (Início)', 'Validade de Acesso (Final)']}
          placeholder={['dd/mm/aaaa', 'dd/mm/aaaa']}
          marginRight={[SPACING.spacing20, SPACING.spacing20]}
          errors={errors}
        />
        <SelectForm
          defaultValue="none"
          control={control}
          formValue="flSituacao"
          placeholder="Selecione"
          listOptions={listaSituacao}
          marginRight={SPACING.spacing20}
          label="Status"
          labelMenu="label"
          valueMenu="value"
          width="150px"
        />
        <Input
          control={control}
          placeholder="E-mail"
          label="E-mail"
          formValue="txEmail"
          marginRight={SPACING.spacing30}
          type="text"
          width="380px"
        />
      </Row>
      <Row
        alignItems="center"
        justifyContent="flex-end"
        marginTop={SPACING.spacing15}
        marginBottom={SPACING.spacing10}
      >
        <Button
          text="Limpar"
          variantButton="text"
          marginRight={SPACING.spacing20}
          onClick={handleReset}
        />
        <Button
          text="Pesquisar"
          endIcon={<MagnifyingGlassIcon />}
          type="submit"
        />
      </Row>
    </Form>
  )
}

export default Filters
